import makeStyles from "@mui/styles/makeStyles";

export const useLinearProgressStyles = makeStyles((theme) => ({
  root: {
    background: theme.palette.common.white,
  },
}));
